import { axios } from '@/utils/request'

export function fetchList (params) {
  return axios({
    url: '/sxCompanyMachine/page',
    method: 'GET',
    params: {
      ...params
    }
  })
}

export function delObj (id) {
  return axios({
    url: `/sxCompanyMachine/${id}`,
    method: 'DELETE'
  })
}
export function getObj (id) {
  return axios({
    url: `/sxCompanyMachine/${id}`,
    method: 'GET'
  })
}
export function addObj (params) {
  return axios({
    url: `/sxCompanyMachine/save`,
    method: 'POST',
    data: {
      ...params
    }
  })
}
export function putObj (params) {
  return axios({
    url: `/sxCompanyMachine/update`,
    method: 'POST',
    data: {
      ...params
    }
  })
}
export function damObj (id) {
  return axios({
    url: `/sxCompanyMachine/damage/${id}`,
    method: 'GET'
    // data: {
    //   ...params
    // }
  })
}

// 项目下拉框
export function dropProjectList () {
  return axios({
    url: `/projectInfo/dropDown`,
    method: 'Get'
  })
}
// 历史转移项目下拉框
export function dropRecordProjectList () {
  return axios({
    url: `/sxCompanyMachineRecord/ProjectTransferDropDown`,
    method: 'Get'
  })
}

// 费用分摊列表
export function apportionList (params) {
  return axios({
    url: `/sxCompanyMachineRecord/transferProject`,
    method: 'GET',
    params: { ...params }
  })
}

// 更新机械转移时间段
export function updateTransferDateRange (params) {
  return axios({
    url: `/sxCompanyMachineRecord/updateTransferProject`,
    method: 'POST',
    data: { ...params }
  })
}

// 机械转移与日志备份
export function transferMachine (params) {
  return axios({
    url: `/sxCompanyMachine/transferMachine`,
    method: 'POST',
    data: {
      ...params
    }
  })
}
